import BusinessIcon from '@mui/icons-material/Business'
import OrganizationsCreate from './Organizations.create'
import OrganizationsEdit from './Organizations.edit'
import OrganizationsList from './Organizations.list'

const resource = {
  list: OrganizationsList,
  create: OrganizationsCreate,
  edit: OrganizationsEdit,
  icon: BusinessIcon,
}

export default resource
